import { NgModule } from '@angular/core';
import { RlCommonModule } from '../rl-common/rl-common.module';
import { AssignmentBriefComponent } from './assignment-brief/assignment-brief.component';
import { AssignmentsListComponent } from './assignments-list/assignments-list.component';
import { AssignmentFullComponent } from './assignment-full/assignment-full.component';
import { AssignmentMenuComponent } from './assignment-menu/assignment-menu.component';
import { EmbeddedViewModule } from '../embedded-view/embedded-view.module';
import { RouterModule } from '@angular/router';
import { AssignmentStatisticsComponent } from './assignment-statistics/assignment-statistics.component';
import { AssignmentGradingComponent } from './assignment-grading/assignment-grading.component';
import { SubmissionViewComponent } from './submission-view/submission-view.component';
import { AssignmentViewComponent } from './assignment-view/assignment-view.component';



@NgModule({
  declarations: [AssignmentBriefComponent, AssignmentsListComponent, AssignmentFullComponent, AssignmentMenuComponent, AssignmentStatisticsComponent, AssignmentGradingComponent, SubmissionViewComponent, AssignmentViewComponent],
  imports: [
    RlCommonModule,
    EmbeddedViewModule,
    RouterModule
  ],
  exports : [
    AssignmentsListComponent,
    AssignmentFullComponent
  ]
})
export class AssignmentModule { }
